import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=728d52b5&lang=pug"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports